import { Mediator, payload } from "modular-openscriptjs";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export default class Tour extends Mediator {
    constructor() {
        super();
        this.events = {
            "system.needs.tour": (ed, event) => {
                this.startTour(event.payload.steps);
            }
        };
    }

    startTour(steps) {
        if (!steps || steps.length === 0) return;

        const driverObj = driver({
            showProgress: true,
            steps: steps.map(step => ({
                element: step.element,
                popover: {
                    title: step.title,
                    description: step.intro,
                    side: "bottom",
                    align: "start"
                }
            }))
        });

        driverObj.drive();
    }
}
